import FinalTransshipment from './final-transshipment.container'

export default FinalTransshipment